import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import ContextProvider from './context';
import "./style.css";
import './index.css';

console.log("env.NODE_ENV ", process.env.NODE_ENV )
console.log("env.VERSION ", process.env.REACT_APP_VERSION )

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}



// NOTE: <React.StrictMode> is not used to prevent double update in useEvent

ReactDOM.render(
  <ContextProvider>
    <App />
  </ContextProvider>
  , document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
